<!-- app/components/Auth/Register/Index.vue -->
<template>
  <div class="flex flex-col md:flex-row-reverse gap-8 pt-0 w-full sm:min-w-175 md:h-auto transition-all duration-300">
    <div class="flex-1 flex flex-col h-full overflow-hidden">
      <UStepper v-model="registerStore.currentStep" :items="stepperSteps" size="md"
                class="mb-6 w-full py-6 px-2 bg-gray-50 dark:bg-gray-800/50 rounded-lg pointer-events-none"
                :ui="{ title: 'text-[10px] sm:text-xs md:text-sm' }">
      </UStepper>
      <UForm @submit.prevent="registerStore.submitRegister" data-cy="auth-register-form"
             class="relative flex-1 w-full overflow-hidden">
        <div class="flex w-full transition-transform duration-500 ease-in-out"
             :style="{ transform: `translateX(-${registerStore.currentStep * 100}%)` }">

          <AuthRegisterStepAccess ref="step0"/>
          <AuthRegisterStepPersonal ref="step1"/>
          <AuthRegisterStepLocation ref="step2"/>
          <AuthRegisterStepDocs ref="step3"/>
          <AuthRegisterStepFinish/>

        </div>

        <div class="flex justify-between items-center pt-6 mt-auto w-full bg-white dark:bg-gray-900">
          <AppButtonTertiary :block="false" v-if="registerStore.currentStep > 0" @click="registerStore.prevStep">
            Voltar
          </AppButtonTertiary>

          <div class="ml-auto">
            <AppButtonPrimary v-if="registerStore.currentStep < steps.length - 1" @click="handleNext" type="button">
              Próximo
            </AppButtonPrimary>
            <AppButtonPrimary v-else @click="registerStore.submitRegister" type="button"
                              data-cy="register-finish-button">
              Finalizar
            </AppButtonPrimary>
          </div>
        </div>
      </UForm>
    </div>

    <aside
        class="hidden md:block w-64 bg-gray-50 dark:bg-gray-800/50 p-6 rounded-lg border border-gray-100 dark:border-gray-800 h-full">
      <h4 class="font-bold text-primary mb-2 flex items-center gap-2">
        <UIcon :name="steps[registerStore.currentStep]?.icon || ''"/>
        {{ steps[registerStore.currentStep]?.title || '' }}
      </h4>
      <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
        {{ steps[registerStore.currentStep]?.description || '' }}
      </p>
    </aside>
  </div>
</template>
<script setup lang="ts">
import type { StepperItem } from '@nuxt/ui'
const uiStore = useUiStore()
const registerStore = useRegisterStore()

defineOptions({
  name: 'AuthRegister'
})

const step0 = ref<any>(null)
const step1 = ref<any>(null)
const step2 = ref<any>(null)
const step3 = ref<any>(null)

const handleNext = async () => {
  let isValid = false
  switch (registerStore.currentStep) {
    case 0:
      if (step0.value) isValid = (await step0.value.validate()).valid
      break
    case 1:
      if (step1.value) isValid = (await step1.value.validate()).valid
      break
    case 2:
      if (step2.value) isValid = (await step2.value.validate()).valid
      break
    case 3:
      if (step3.value) isValid = (await step3.value.validate()).valid
      break
  }
  registerStore.nextStep(isValid)
}

const steps: StepperItem[] = [
    { title: 'Acesso', icon: 'ph:shield-check', description: 'Crie suas credenciais de acesso à plataforma.' },
    { title: 'Pessoal', icon: 'ph:user', description: 'Nos informe quem você é para identificarmos seu perfil.' },
    { title: 'Localização', icon: 'ph:map-pin', description: 'Informe onde você reside atualmente.' },
    { title: 'Documentos', icon: 'ph:identification-card', description: 'Insira os dados dos seus documentos e informações socioeconômicas.' },
    { title: 'Conclusão', icon: 'ph:identification-card', description: 'Verifique seu nome completo, ele será usado na emissão do certificado.' }
]

const stepperSteps = computed(() => steps.map(({ title, icon }) => ({ title, icon })))

watch(() => uiStore.isAuthModalOpen, async (isOpen) => {
  if (!isOpen) {
    registerStore.resetState();   // reseta o state do Pinia para os valores iniciais
    // Reseta o Regle ($dirty, $errors)
    step0.value?.reset()
    step1.value?.reset()
    step2.value?.reset()
    step3.value?.reset()
  }
})
</script>